import React, { useState, useMemo, useEffect } from 'react';
import { Button } from 'components/Base';
import PersistentTable from './PersistentTable';

type RatioYearFilterProps = {
  key: string;
  tableId: string;
  columns: any[];
  data: any[];
  rowClick?: Function;
  height?: any;
};

const RatioYearFilter = ({
  key,
  tableId,
  columns,
  data,
  rowClick,
  height = '1000px'
}: RatioYearFilterProps) => {
  const initialVisibilityState = useMemo(
    () =>
      columns.reduce((acc: any, col: any) => {
        acc[col.accessorKey] = true;
        return acc;
      }, {}),
    [columns]
  );

  const [visibleColumns, setVisibleColumns] = useState(initialVisibilityState);

  const filterColumnsByYear = (year: any) => {
    setVisibleColumns((prev: any) => {
      const newVisibility = { ...prev };
      columns
        .filter((col: any) => col.accessorKey.includes('_y'))
        .forEach((col: any) => {
          newVisibility[col.accessorKey] = false;
          if (year === '_y' || col.accessorKey.includes(year)) {
            newVisibility[col.accessorKey] = true;
          }
        });
      return newVisibility;
    });
  };

  const filteredColumns = columns.filter(
    (col: any) => visibleColumns[col.accessorKey]
  );

  const [performancePeriod, setPerformancePeriod] = useState('1Y');

  const performancePeriods = {
    '1Y': 'one_y',
    '3Y': 'three_y',
    '5Y': 'five_y',
    ALL: '_y'
  } as any;

  useEffect(() => {
    // Apply the filter based on the initial performance period
    filterColumnsByYear(performancePeriods[performancePeriod]);
  }, [performancePeriod, columns, performancePeriods]);

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          marginBottom: '1rem',
          justifyContent: 'flex-end'
        }}
      >
        {Object.entries(performancePeriods).map(([label, param]) => (
          <Button
            key={label}
            style={{
              height: '24px',
              paddingLeft: '12px',
              paddingRight: '12px',
              minWidth: '45px'
            }}
            color={performancePeriod === label ? 'primary' : 'default'}
            gray={performancePeriod === label ? false : true}
            onClick={() => {
              setPerformancePeriod(label);
              filterColumnsByYear(param);
            }}
          >
            {label}
          </Button>
        ))}
      </div>
      <PersistentTable
        key={key}
        tableId={tableId}
        columns={filteredColumns}
        data={data}
        rowClick={rowClick}
        height={height}
      />
    </>
  );
};

export default RatioYearFilter;
